export default __webpack_public_path__ + "static/media/logo-azul.5609b142.svg";